<template>
  <div style="padding-left: 30px;">
    <el-row :gutter="40" class="panel-group">
      <el-col :xs="12" :sm="12" :lg="6" class="card-panel-col">
        <div class="card-panel">
          <div class="card-panel-icon-wrapper icon-message">
            <svg-icon icon-class="gongdian" class-name="card-panel-icon" />
          </div>
          <div class="card-panel-description">
            <div class="card-panel-text">
              变配电室数量
            </div>
            <count-to :start-val="0" :end-val="peidianshi" :duration="3000" class="card-panel-num" />座
          </div>
        </div>
      </el-col>
      <el-col :xs="12" :sm="12" :lg="6" class="card-panel-col">
        <div class="card-panel">
          <div class="card-panel-icon-wrapper icon-money">
            <svg-icon icon-class="bianyaqi4" class-name="card-panel-icon" />
          </div>
          <div class="card-panel-description">
            <div class="card-panel-text">
              变压器台数
            </div>
            <count-to :start-val="0" :end-val="bianyaqi" :duration="3000" class="card-panel-num" />台
          </div>
        </div>
      </el-col>
      <el-col :xs="12" :sm="12" :lg="6" class="card-panel-col">
        <div class="card-panel">
          <div class="card-panel-icon-wrapper icon-shopping">
            <svg-icon icon-class="huilu" class-name="card-panel-icon" />
          </div>
          <div class="card-panel-description">
            <div class="card-panel-text">
              监控回路
            </div>
            <count-to :start-val="0" :end-val="huilu" :duration="3000" class="card-panel-num" />台
          </div>
        </div>
      </el-col>
    </el-row>
    <el-row :gutter="40" class="panel-group">
      <el-col :xs="12" :sm="12" :lg="6" class="card-panel-col">
        <div class="card-panel">
          <div class="card-panel-icon-wrapper icon-message">
            <svg-icon icon-class="zhuangjirongliang" class-name="card-panel-icon" />
          </div>
          <div class="card-panel-description">
            <div class="card-panel-text">
              装机容量
            </div>
            <count-to :start-val="0" :end-val="rongliang" :duration="3000" class="card-panel-num" />kAV
          </div>
        </div>
      </el-col>
      <el-col :xs="12" :sm="12" :lg="6" class="card-panel-col">
        <div class="card-panel">
          <div class="card-panel-icon-wrapper icon-money">
            <svg-icon icon-class="dianyadengji" class-name="card-panel-icon" />
          </div>
          <div class="card-panel-description">
            <div class="card-panel-text">
              电压等级
            </div>
            <count-to :start-val="0" :end-val="dianyadengji" :duration="3000" class="card-panel-num" />kV
          </div>
        </div>
      </el-col>
      <el-col :xs="12" :sm="12" :lg="6" class="card-panel-col">
        <div class="card-panel">
          <div class="card-panel-icon-wrapper icon-shopping">
            <svg-icon icon-class="shenbaoxuliang" class-name="card-panel-icon" />
          </div>
          <div class="card-panel-description">
            <div class="card-panel-text">
              申报需量
            </div>
            <count-to :start-val="0" :end-val="shenbao" :duration="3000" class="card-panel-num" />kW
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
  import CountTo from 'vue-count-to'
  export default {
    name: "xmgk",
    data () {
      return {
        peidianshi: 0,
        bianyaqi: 0,
        huilu: 0,
        rongliang: 0,
        dianyadengji: 0,
        shenbao: 0
      };
    },
    props: {
      date: {
        type: Object
      },
      dateType: {
        type: Object
      }
    },
    components: { CountTo },
    created () {
      this.searchProductInfo()
    },
    mounted () {

    },
    computed: {

    },
    watch: {

    },
    methods: {
      searchProductInfo () {
        const projectId = this.$getCookie("projectId");
        this.$http
          .post(
            "bma-distribution-service/monthReport/getProductInfo", {
            projectId: projectId,
            date: this.date,
            dateType: this.dateType
          }
          )
          .then((res) => {
            if (res.data) {
              this.peidianshi = res.data.peidianshi
              this.bianyaqi = res.data.bianyaqi
              this.huilu = res.data.huilu
              this.rongliang = res.data.rongliang
              this.dianyadengji = res.data.dianyadengji
              this.shenbao = res.data.shenbao
            }
          });
      },
    },
  };
</script>

<style lang="scss" scoped>
  .panel-group {
    margin-top: 18px;

    .card-panel-col {
      margin-bottom: 32px;
    }

    .card-panel {
      height: 108px;
      cursor: pointer;
      font-size: 12px;
      position: relative;
      overflow: hidden;
      color: #666;
      background: #fff;
      box-shadow: 4px 4px 40px rgba(0, 0, 0, .05);
      border-color: rgba(0, 0, 0, .05);

      &:hover {
        .card-panel-icon-wrapper {
          color: #fff;
        }

        .icon-people {
          background: #40c9c6;
        }

        .icon-message {
          background: #36a3f7;
        }

        .icon-money {
          background: #f4516c;
        }

        .icon-shopping {
          background: #34bfa3
        }
      }

      .icon-people {
        color: #40c9c6;
      }

      .icon-message {
        color: #36a3f7;
      }

      .icon-money {
        color: #f4516c;
      }

      .icon-shopping {
        color: #34bfa3
      }

      .card-panel-icon-wrapper {
        float: left;
        margin: 14px 0 0 14px;
        padding: 16px;
        transition: all 0.38s ease-out;
        border-radius: 6px;
      }

      .card-panel-icon {
        float: left;
        font-size: 48px;
      }

      .card-panel-description {
        float: right;
        font-weight: bold;
        margin: 26px;
        margin-left: 0px;
        text-align: right;

        .card-panel-text {
          line-height: 18px;
          color: rgba(0, 0, 0, 0.45);
          font-size: 16px;
          margin-bottom: 12px;
        }

        .card-panel-num {
          font-size: 20px;
        }
      }
    }
  }

  @media (max-width:550px) {
    .card-panel-description {
      display: none;
    }

    .card-panel-icon-wrapper {
      float: none !important;
      width: 100%;
      height: 100%;
      margin: 0 !important;

      .svg-icon {
        display: block;
        margin: 14px auto !important;
        float: none !important;
      }

      .i {
        display: block;
        margin: 14px auto !important;
        float: none !important;
        font-size: 48px;
      }
    }
  }
</style>